export default __webpack_public_path__ + "static/RickGilchrist-f132d5a2d8a1617060ecdf4d42971186.jpg";